export default {
    //websocket
    webSocket: {},
    setWs: function (ws) {
        this.webSocket = ws
    }
 
}